import { DynamicPropertyType } from 'types/DynamicPropertyType';

import type { IDynamicProperty } from './IDynamicProperty';
import type Asset from './Types/Asset';
import type Dimensions from './Types/Dimensions';
import type SVGText from './Types/SVGText';
import type Template from './Types/Template';

export function ifAsset(
    dynamicProperty: IDynamicProperty<any> | undefined
): Asset | undefined {
    return dynamicProperty?.type === DynamicPropertyType.ASSET
        ? (dynamicProperty as Asset)
        : undefined;
}

export function ifDimensions(
    dynamicProperty: IDynamicProperty<any> | undefined
): Dimensions | undefined {
    return dynamicProperty?.type === DynamicPropertyType.DIMENSIONS
        ? (dynamicProperty as Dimensions)
        : undefined;
}

export function ifSVGText(
    dynamicProperty: IDynamicProperty<any> | undefined
): SVGText | undefined {
    return dynamicProperty?.type === DynamicPropertyType.SVGText
        ? (dynamicProperty as SVGText)
        : undefined;
}

export function ifTemplate(
    dynamicProperty: IDynamicProperty<any> | undefined
): Template | undefined {
    return dynamicProperty?.type === DynamicPropertyType.TEMPLATE
        ? (dynamicProperty as Template)
        : undefined;
}
